import React from 'react';
import classNames from 'classnames';

import { Text, textVariantsEnum, fontWeightEnum } from '@components/Text';
import { IconBadge, iconBadgeSizes } from '@components/IconBadge';

import styles from './SettingsFieldCard.module.scss';

export const settingsFieldCardLayouts = {
  column: 'column',
  row: 'row',
};

// Default control width for a `layout="row"` field's input/dropdown — shared
// so every row-style settings form lines its controls up consistently.
export const SETTINGS_FIELD_CONTROL_WIDTH = '320px';

export const SettingsFieldCard = ({
  icon,
  iconBg = 'indigo-100',
  label,
  helperText,
  children,
  className,
  layout = settingsFieldCardLayouts.column,
}) => {
  const isRow = layout === settingsFieldCardLayouts.row;

  return (
    <div
      className={classNames(
        styles.fieldCard,
        { [styles.fieldCard_row]: isRow },
        className
      )}
    >
      <div className={styles.labelRow}>
        <IconBadge size={iconBadgeSizes.sm} bg={iconBg} icon={icon} />
        <div className={styles.labelText}>
          <Text
            variant={textVariantsEnum.Text_sm}
            fontWeight={fontWeightEnum.Semibold}
            color="gray-800"
          >
            {label}
          </Text>
          {isRow && helperText && (
            <Text
              variant={textVariantsEnum.Text_xs}
              fontWeight={fontWeightEnum.Normal}
              color="gray-500"
            >
              {helperText}
            </Text>
          )}
        </div>
      </div>
      <div className={styles.control}>{children}</div>
      {!isRow && helperText && (
        <Text
          variant={textVariantsEnum.Text_xs}
          fontWeight={fontWeightEnum.Normal}
          color="gray-500"
        >
          {helperText}
        </Text>
      )}
    </div>
  );
};

SettingsFieldCard.displayName = 'SettingsFieldCard';
